@import (reference) '../../../../../constants/spacing.module.less';

.tracking-number-container {
  display: flex;
  gap: @space-4;
  align-items: center;
}

.tracking-number-link {
  color: var(--primary--link--text-color--5);

  &.is-voided {
    text-decoration: line-through currentcolor;
  }
}

.tracking-mdash {
  color: var(--light--text-color--1);
}

.copy-tracking-number-button {
  height: 20px;
  width: 20px;
  color: var(--primary--link--text-color--5);
}
